import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { cardPaint } from "@/components/shapes/shared/card-paint";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { hasTrack, musicFields } from "./music-content";
import { MusicFace } from "./music-face";

/** A track: its face (`MusicFace`); the player mounts only in the frame. */
export function MusicCardPreview(props: CardPreviewProps) {
  const fields = musicFields(props.source);
  if (!hasTrack(fields)) return <GenericCardPreview {...props} />;
  return (
    <MusicFace
      fields={fields}
      density={props.density}
      paint={cardPaint(props.frame).background}
      testIdPrefix="music-card"
    />
  );
}
